import { render, staticRenderFns } from "./alt-todays-total.vue?vue&type=template&id=4d11a454"
import script from "./alt-todays-total.vue?vue&type=script&lang=js"
export * from "./alt-todays-total.vue?vue&type=script&lang=js"
import style0 from "./alt-todays-total.vue?vue&type=style&index=0&id=4d11a454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports